import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import ErrorsCore from '../AfrCore/ErrorsCore';
import UserRoleEnum from '../../redux/UserSlice';

const CR29ErrorsA = (props: any) => {

    return (
        <React.Fragment>
            <ErrorsCore userRole={UserRoleEnum.Admin} taxType={TaxonomyTypeEnum.COURT_REPORTING_29} reportName="Court Report 29.0085" />
        </React.Fragment>
    );
}

export default CR29ErrorsA;